<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- <error-toast :text="errorToastText" ref="errorToast"></error-toast> -->
  </div>
</template>

<script>

import errorToast from '@/components/base/errorToast'
import { mapMutations } from 'vuex'
import { isLogin } from '@/util/index.js'
import { isApp, isIOS, isAndroid, isWX } from "@/api/device";
import { fetchUserInfo } from "@/api/interface.js"
export default {
  name: 'App',
  data() {
    return {
      isLogin: (() => {
        return isLogin()
      })(),
      errorToastText: '',
    }
  },
  beforeCreate() {
    // window["getAppTokenData"] = res => {
    //   console.log('获取apptoken,before')
    //   this.getAppTokenData(res)
    // }
  },
  created() {
    this.getConfigJson()
    window["getAppTokenData"] = res => {
      console.log('获取apptoken,created')
      this.getAppTokenData(res)
    }
    if (isApp()) {
      this.againGetAppToken()
    }
  },
  methods: {
    againGetAppToken() {
      console.log('获取apptoken,created')
      if (isIOS()) {
        return window.webkit.messageHandlers.againGetAppToken.postMessage({})
      }
      if (isAndroid()) {
        return window.JsMode.againGetAppToken()
      }
    },
    getAppTokenData(res) {
      console.log('获取apptoken')
      this.setToken(`Bearer ${res}`)
      this.setExpire((new Date().getTime() + 86400 * 1000) - 10000)
      this.isLogin = isLogin()
      if (this.$route.name !== 'regist') {
        this.go()
      }
    },
    go() {
      fetchUserInfo().then(res => {
        // 1普通合伙人  2合伙管家  3总代理  4管理员
        let userType = res.response.Type
        let isCheckState = res.response.IsCheckState
        // 存储登陆用户类型
        localStorage.setItem('userType', JSON.stringify({
          userType
        }))
        localStorage.setItem('isCheckState', JSON.stringify({
          isCheckState
        }))
        // if (userType === 4) {
        //   this.$router.push({
        //     path: '/admin'
        //   })
        // } else {
        this.$router.push({
          path: '/'
        })
        // }
      })
    },
    ...mapMutations({
      setToken: 'SET_TOKEN',
      setExpire: 'SET_EXPIRE',
    })
  },
  components: {
    errorToast
  },
}
</script>

<style type="scss">
@import "./sass/reset.scss";

html,
body {
  background-color: #f5f5f5;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #333;
  overflow-x: hidden;
  overflow-y: auto;
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue